import React from 'react';
import { AutocompleteType } from '@philips-internal/oswald-ui-constants';
import { Input } from '../input/input.js';
export function FakeInput({ enabled, externalAction, onFocus, placeholder, readOnly, valid = true, value }) {
    return (React.createElement("div", { className: "c-autocomplete__search" },
        React.createElement(Input, { autoComplete: AutocompleteType.OFF, autoCorrect: false, enabled: enabled, externalAction: externalAction, onFocus: onFocus, placeholder: placeholder, readOnly: readOnly, valid: valid, value: value })));
}
export function ModalInput({ onBlur, onChange, onFocus, placeholder, value }) {
    return (React.createElement("div", { className: "c-autocomplete__search" },
        React.createElement(Input, { autoComplete: AutocompleteType.OFF, autoFocus: true, autoSelect: true, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, tabIndex: 1, value: value })));
}
//# sourceMappingURL=components.js.map